import React from "react";
import { getModuleLabel } from "../utils";

const moduleColumn = {
    id: "module",
    label: "Module",
    sortable: false,
    render: (_, { value }) => <span>{getModuleLabel(value)}</span>,
};

const caseColumns = [
    { id: "fileNo", label: "File No.", sortable: false },
    moduleColumn,
    { id: "type", label: "Type", sortable: false },
    { id: "status", label: "Status", sortable: false },
    { id: "startDateString", label: "Start Date", sortable: false },
];

const withIndex = (columns) => columns.map((column, i) => ({ ...column, index: i + 1, disablePadding: false }));

/** Columns for the cases of an already selected client. */
export const clientFileCaseColumns = withIndex(caseColumns);

/** Columns for a case search across all clients. */
export const searchFileCaseColumns = withIndex([
    caseColumns[0],
    { id: "clientFullName", label: "Client", sortable: false },
    ...caseColumns.slice(1),
]);
